import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";

import type { BrandSelectOption } from "@/features/brands/shared/hooks/useGetBrandsByProjectId";

export function useDefaultRestrictAiAssetsFromBrand(
  brandFieldName: "brand" | "brandId",
  brands: BrandSelectOption[] | undefined,
) {
  const { setValue, watch } = useFormContext();
  const rawBrandId = watch(brandFieldName);
  const selectedBrandId =
    rawBrandId === null || rawBrandId === undefined ? null : Number(rawBrandId);
  const lastAppliedBrandId = useRef<null | number | undefined>();

  useEffect(() => {
    if (!brands) return;
    if (lastAppliedBrandId.current === selectedBrandId) return;
    lastAppliedBrandId.current = selectedBrandId;

    if (selectedBrandId === null || Number.isNaN(selectedBrandId)) return;

    const brand = brands.find((option) => option.id === selectedBrandId);

    if (brand) {
      setValue("restrictAiAssets", brand.restrictAiAssets);
    }
  }, [brands, selectedBrandId, setValue]);
}
